import { render, staticRenderFns } from "./CovenantDetail.vue?vue&type=template&id=6e2162a8&scoped=true&"
import script from "./CovenantDetail.vue?vue&type=script&lang=js&"
export * from "./CovenantDetail.vue?vue&type=script&lang=js&"
import style0 from "./CovenantDetail.vue?vue&type=style&index=0&id=6e2162a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2162a8",
  null
  
)

export default component.exports